export default "__VITE_ASSET__l8nnhX0L__"